import React, { Fragment, useState } from "react";
import "./styles.css";
import { Space, Spin } from "antd";
import PropagateLoader from "react-spinners/PropagateLoader";
import { LoadingOutlined } from "@ant-design/icons";
const LoadingPage: React.FC = () => {
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
  return (
      <div className="loading">
        <div className="divImgJust">
          <img
            src="https://res.cloudinary.com/ddoltb8nf/image/upload/v1662075065/just/Logo-just-Danger_avb1dy.png"
            alt="logo"
          />
        </div>
        <div className="wrapper">
          <div className="spinner">
            <div className="bounce1"></div>
            <div className="bounce2"></div>
            <div className="bounce3"></div>
          </div>
        </div>
      </div>
  );
};

export default LoadingPage;
